import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentFooter } from '../../../../../layout/Content'
import ProductsPriceListFooterStyle from './css/ProductsPriceListFooterStyle'
import ReportsController from '../../../../ReportsController'
import { appContext } from '../../../../../../App'

function ProductsPriceListFooter(props) {
  const app = useContext(appContext)
  const setContent = app.content[1]
  return (
    <ContentFooter>
      <div className='content-footer-container'>
        <div className='action-btn-container'>
          <button
            onClick={() => { setContent(<ReportsController />) }}
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='list-alt'/>&nbsp;Back to Reports
          </button>
        </div>
        <div className='action-btn-container'>
          <button
            onClick={ () => { window.print() } }
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='print'/>&nbsp;Print
          </button>
        </div>
      </div>
      <ProductsPriceListFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(ProductsPriceListFooter)